import { parseActionStructure } from '@/common/utils/parseActionStructure'

/** Resolve startup-action window type from platform/action response `structure` field. */
export function resolveStartupActionWindowType(documentData: Record<string, unknown>): string {
  return parseActionStructure(documentData.structure).windowType ?? ''
}
